import { IsNullOrEmpty } from "./NullEmptyHelpers";

const DEFAULT_TIMEOUT_MESSAGE =
  "Your request has timed out. Please refine your query by applying filters such as narrowing the date range or selecting a specific location and/or payer.";

function GetCustomError(sourceError) {
  const response = sourceError && sourceError.response ? sourceError.response : {};
  const status = IsNullOrEmpty(response.status) ? -1 : response.status;

  let description = IsNullOrEmpty(response.data) ? "" : response.data;

  if (status === 408 && IsNullOrEmpty(description)) {
    description = DEFAULT_TIMEOUT_MESSAGE;
  }

  return {
    message:
      sourceError && !IsNullOrEmpty(sourceError.message) ? sourceError.message : "",
    code: status,
    description,
  };
}

// Axios errors carry the full request config (headers, body) and the response payload.
// Sending that object to Application Insights would ship request/response data — potentially PHI —
// into telemetry, so log a plain Error built only from the message.
function GetSanitizedTelemetryError(sourceError) {
  const message =
    sourceError && !IsNullOrEmpty(sourceError.message)
      ? sourceError.message
      : "Unknown error";

  const sanitizedError = new Error(message);

  if (sourceError && !IsNullOrEmpty(sourceError.name)) {
    sanitizedError.name = sourceError.name;
  }

  return sanitizedError;
}

// Safe, non-payload metadata for telemetry properties. Query strings are stripped because export
// filters (user, dates, locations, payers) travel in the URL.
function GetSafeTelemetryProperties(sourceError) {
  const response = sourceError && sourceError.response ? sourceError.response : null;
  const request = sourceError && sourceError.request ? sourceError.request : null;

  let requestPath = "";
  if (request && !IsNullOrEmpty(request.responseURL)) {
    try {
      requestPath = new URL(request.responseURL).pathname;
    } catch (urlParseError) {
      requestPath = "";
    }
  }

  return {
    errorName: sourceError && !IsNullOrEmpty(sourceError.name) ? sourceError.name : "",
    errorCode: sourceError && !IsNullOrEmpty(sourceError.code) ? sourceError.code : "",
    httpStatus:
      response && !IsNullOrEmpty(response.status) ? String(response.status) : "",
    requestPath,
  };
}

export {
  GetCustomError,
  GetSanitizedTelemetryError,
  GetSafeTelemetryProperties,
  DEFAULT_TIMEOUT_MESSAGE,
};